import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Camera, Wifi, WifiOff, Eye, Edit2, Trash2, MoreVertical, Signal } from 'lucide-react';
import { DEVICE_TYPES } from './CCTVConstants';

export const CCTVDeviceCard = ({ device, onView, onEdit, onDelete }) => {
  const isOnline = device.status?.is_online;
  const TypeIcon = DEVICE_TYPES.find(t => t.id === device.device_type)?.icon || Camera;

  return (
    <Card className={`cursor-pointer transition-all hover:shadow-lg ${!isOnline ? 'opacity-75' : ''}`} data-testid={`device-card-${device.id}`}>
      <CardContent className="p-4">
        <div className="relative aspect-video bg-gray-900 rounded-lg mb-3 overflow-hidden">
          {device.thumbnail_url ? (
            <img src={device.thumbnail_url} alt={device.name} className="w-full h-full object-cover" />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center">
              <Camera className="h-12 w-12 text-gray-600" />
            </div>
          )}
          <div className="absolute top-2 right-2">
            <Badge variant={isOnline ? "default" : "destructive"} className="gap-1">
              {isOnline ? <Wifi className="h-3 w-3" /> : <WifiOff className="h-3 w-3" />}
              {isOnline ? 'Online' : 'Offline'}
            </Badge>
          </div>
          {device.recording_enabled && isOnline && (
            <div className="absolute top-2 left-2">
              <Badge variant="destructive" className="gap-1 animate-pulse">
                <div className="w-2 h-2 bg-white rounded-full" />REC
              </Badge>
            </div>
          )}
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <h4 className="font-medium truncate">{device.name}</h4>
            <TypeIcon className="h-4 w-4 text-muted-foreground" />
          </div>
          <p className="text-sm text-muted-foreground truncate">{device.serial_number}</p>
          {device.location && (
            <p className="text-xs text-muted-foreground flex items-center gap-1"><Signal className="h-3 w-3" />{device.location}</p>
          )}
        </div>
        <div className="flex items-center gap-2 mt-4">
          <Button size="sm" className="flex-1" onClick={() => onView(device)}><Eye className="h-4 w-4 mr-1" />View</Button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild><Button size="sm" variant="outline"><MoreVertical className="h-4 w-4" /></Button></DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem onClick={() => onEdit(device)}><Edit2 className="h-4 w-4 mr-2" /> Edit</DropdownMenuItem>
              <DropdownMenuItem className="text-destructive" onClick={() => { if (window.confirm('Delete this device?')) onDelete(device.id); }}>
                <Trash2 className="h-4 w-4 mr-2" /> Delete
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </CardContent>
    </Card>
  );
};
